import React from 'react';
import { Dialog, Transition } from '@headlessui/react';
import { Fragment } from 'react';
import { CheckCircleIcon, ClockIcon, ArchiveBoxIcon } from '@heroicons/react/24/outline';

interface ApplicationModalProps {
  isOpen: boolean;
  onClose: () => void;
  onApplied: () => void;
  onApplyLater: () => void;
  onArchive: () => void;
  jobTitle: string;
  company: string;
}

const ApplicationModal: React.FC<ApplicationModalProps> = ({
  isOpen,
  onClose,
  onApplied,
  onApplyLater,
  onArchive,
  jobTitle,
  company
}) => {
  return (
    <Transition appear show={isOpen} as={Fragment}>
      <Dialog as="div" className="relative z-50" onClose={onClose}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-black/25" />
        </Transition.Child>

        <div className="fixed inset-0 overflow-y-auto">
          <div className="flex min-h-full items-center justify-center p-4">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95"
            >
              <Dialog.Panel className="w-full max-w-md transform overflow-hidden rounded-2xl bg-white p-6 text-left align-middle shadow-xl transition-all">
                <div className="mb-6">
                  <Dialog.Title as="h3" className="text-lg font-semibold text-gray-900">
                    Did you apply to this position?
                  </Dialog.Title>
                  <p className="mt-2 text-sm text-gray-500">
                    {jobTitle} at {company}
                  </p>
                </div>

                <div className="space-y-3">
                  <button
                    onClick={onApplied}
                    className="w-full flex items-center justify-center space-x-2 px-4 py-3 rounded-lg bg-green-50 text-green-700 hover:bg-green-100 transition-colors"
                  >
                    <CheckCircleIcon className="w-6 h-6" />
                    <span>Yes, I applied!</span>
                  </button>

                  <button
                    onClick={onApplyLater}
                    className="w-full flex items-center justify-center space-x-2 px-4 py-3 rounded-lg bg-blue-50 text-blue-700 hover:bg-blue-100 transition-colors"
                  >
                    <ClockIcon className="w-6 h-6" />
                    <span>Apply Later</span>
                  </button>

                  <button
                    onClick={onArchive}
                    className="w-full flex items-center justify-center space-x-2 px-4 py-3 rounded-lg bg-gray-50 text-gray-700 hover:bg-gray-100 transition-colors"
                  >
                    <ArchiveBoxIcon className="w-6 h-6" />
                    <span>Archive</span>
                  </button>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition>
  );
};

export default ApplicationModal;